import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-ext-badge',
  standalone: true,
  imports: [CommonModule],
  template: `<span class="ext-pill" [title]="title">{{ text }}</span>`,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        vertical-align: middle;
        margin-left: 8px;
        flex-shrink: 0;
        line-height: 1;
      }
      @keyframes ext-shimmer {
        0% {
          background-position: -200% center;
        }
        100% {
          background-position: 200% center;
        }
      }
      @keyframes ext-pulse-glow {
        0%,
        100% {
          box-shadow: 0 1px 4px rgba(99, 102, 241, 0.25);
        }
        50% {
          box-shadow: 0 2px 8px rgba(99, 102, 241, 0.45);
        }
      }
      .ext-pill {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 18px;
        padding: 0 7px;
        border-radius: 999px;
        background: linear-gradient(
          135deg,
          #6366f1 0%,
          #3b82f6 40%,
          #a5b4fc 60%,
          #3b82f6 80%,
          #6366f1 100%
        );
        background-size: 200% auto;
        color: #ffffff;
        font-size: 9px;
        font-weight: 700;
        letter-spacing: 0.7px;
        text-transform: uppercase;
        line-height: 1;
        box-shadow: 0 1px 4px rgba(99, 102, 241, 0.25);
        animation:
          ext-shimmer 2.5s linear infinite,
          ext-pulse-glow 2s ease-in-out infinite;
        cursor: default;
        user-select: none;
        white-space: nowrap;
      }
    `,
  ],
})
export class ExtBadgeComponent {
  @Input() text: string = 'EXT';
  @Input() title: string = 'External Role';
}
